import { render, staticRenderFns } from "./management.vue?vue&type=template&id=6a3b4f5e&scoped=true"
import script from "./management.vue?vue&type=script&lang=ts"
export * from "./management.vue?vue&type=script&lang=ts"
import style0 from "./management.vue?vue&type=style&index=0&id=6a3b4f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b4f5e",
  null
  
)

export default component.exports